export function externalLink() {
  // ==UserScript==
  // @match *://*/*
  // ==/UserScript==

  (function (anchors) {
    for (var i = 0, l = anchors.length; i < l; i++) {
      if (location.host !== anchors[i].host) {
        const href = anchors[i].getAttribute("href");
        if (href && href !== "#" && href !== "javascript:void(0)") {
          anchors[i].setAttribute("target", "_blank");
        }
      }
    }
  })(document.querySelectorAll("a"));
}